export const props = {
  id: Number,

  uuid: {
    type: String,
    required: true
  },

  editable: {
    type: Boolean,
    default: true
  },

  isEditing: {
    type: Boolean,
    default: true
  },

  showReorder: {
    type: Boolean,
    default: false
  },

  rootData: Object,

  order: Number,
};

export function dzID() {
  return `dz-ele-${Kadenze.Util.generateUUID()}`;
}

export function generateID(tag='') {
  return `${tag}-${Kadenze.Util.generateUUID()}`;
}

export function formatDate(d) {
  return moment(d).format('MMMM D, YYYY');
}

export function bindFile({ size, name }, { file }) {
  this.file = file;
  this.contentSize = size;
  this.contentName = name;
  this.removeContent = false;
}

export function curFileObj() {
  return this.file ? {
    path: this.file.url,
    size: this.contentSize,
    name: this.contentName
  } : false;
}
